import chroma from "chroma-js";

import { getChartColor } from "../charts/chartTheme";

const c0 = chroma(getChartColor(0));
const c1 = chroma(getChartColor(1));

export const greenBlueColorway = [c1.darken(0.8), c1.darken(0.2), c1.darken(-0.6), c0.darken(0.4), c0.darken(-0.1), c0.darken(-0.6)].map(
    (color) => color.hex()
);
